import { PRMCodes, AIRPORT_RESTRICTED_CODES } from './constants';

// Human-readable descriptions keyed by PRM / special-assistance code.
// This is the single dictionary of descriptions; the list of codes itself
// lives in constants.js (PRMCodes) so the two can never diverge.
const descriptions = {
    WCHR: "WCHR - Passenger can walk short distance up or down stairs",
    WCHS: "WCHS - Passenger can walk short distances but not up or down stairs",
    WCHC: "WCHC - Passenger cannot walk any distance and will require the aisle chair to board",
    BLND: "BLND - Passenger is blind or has reduced vision",
    MEDA: "MEDA - Medical Case",
    DEAF: "DEAF - Passenger is deaf or hard of hearing",
    DPNA: "DPNA - Disabled Passenger with acquired brain injury, intellectual or developmental disability",
    SVAN: "SVAN - Passenger is travelling with a service dog",
    LNYD: "LNYD - Passenger with a hidden or non-visible disability",
    WCMP: "WCMP - Passenger is travelling with a manual wheelchair",
    WCLB: "WCLB - Passenger is travelling with a Lithium ion wheelchair",
    WCHP: "WCHP - Passenger can walk short distances but requires a wheelchair to and from the aircraft and assistance on and off their seat",
    WCBW: "WCBW - Passenger is travelling with a wheelchair with a wet cell (spillable) battery",
    WCBD: "WCBD - Passenger is travelling with a wheelchair with a dry cell battery",
    STCR: "STCR - Passenger is travelling on a stretcher",
    PETC: "PETC - Passenger is travelling with a pet in cabin",
    PPOC: "PPOC - Passenger is travelling with a portable oxygen concentrator",
    ESAN: "ESAN - Passenger is travelling with an emotional support animal.",
    OXYG: "OXYG - Passenger will require oxygen.",
    MAAS: "MAAS - Meet and assist",
    YPTA: "YPTA - Young passenger requiring assistance",
    // Retained for description look-ups on historical bookings; not a selectable code.
    BGGY: "BGGY - Passenger is travelling with a buggy",
};

// Build an option object for the assistance dropdown. Codes without a bespoke
// description fall back to displaying the raw code.
const toOption = (value) => ({ value, label: descriptions[value] || value });

// Full option set (all codes), derived from the single source of truth.
const codes = PRMCodes.map(toOption);

export default codes;

// Options for the assistance dropdown, gated by airport authority. A code is
// included unless it is airport-restricted (see AIRPORT_RESTRICTED_CODES) and
// the current authority is not in its allow-list — e.g. LNYD only for DUB,
// PETC only for BFS.
export const getPRMCodeOptions = (authority) =>
    PRMCodes
        .filter((code) => {
            const allowed = AIRPORT_RESTRICTED_CODES[code];
            return !allowed || (authority && allowed.includes(authority));
        })
        .map(toOption);

export const getCodeDescription = (code) => descriptions[code] || "";
